import { render, staticRenderFns } from "./person-search.vue?vue&type=template&id=3be078d2&"
import script from "./person-search.vue?vue&type=script&lang=js&"
export * from "./person-search.vue?vue&type=script&lang=js&"
import style0 from "./person-search.vue?vue&type=style&index=0&id=3be078d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports